const MESSAGES = {
  COMMON: {
    DATA_REFRESHED: "Data refreshed",
    NO_CHANGES_TO_SAVE: "No changes to save",
    LOADING_DATA: "Error in loading the data",
    GRID_DATA_FETCH_FAILED: "Something went wrong",
    NO_ROUTE_SELECTED: "Please select at least one route to print",
  },
  ANCHORPOINT: {
    DROP_SUCCESS: "Successfully dropped anchor point",
    DROP_FAILURE: "Error while dropping anchor point",
    DISABLED_ANCHORPOINT: "Enable anchor point to assign routes",
  },
  FIND_NEARBY_ROUTES: {
    NO_ROUTES: "No near by routes found",
    FETCH_DATA_FAILURE: "Error while fetching near by routes",
  },
  FIRST_STOP: {
    MARK_SUCCESS: "Successfully marked as first stop",
    MARK_FAILURE: "Error while marking first stop",
    UNMARK_SUCCESS: "Successfully unmarked as first stop",
    UNMARK_FAILURE: "Error while unmarking last stop",
  },
  LAST_STOP: {
    MARK_SUCCESS: "Successfully marked as last stop",
    MARK_FAILURE: "Error while marking last stop",
    UNMARK_SUCCESS: "Successfully unmarked as last stop",
    UNMARK_FAILURE: "Error while unmarking last stop",
  },
  RUN_TSP: {
    FAILURE: "Route optimization failed",
  },
  ROUTE_PUBLISH: {
    START_SUCCESS: "Started route publishing",
    START_FAILURE: "Error publishing routes",
  },
  ROUTE_OPTIMIZATION: {
    START_SUCCESS: "Route optimization started",
    START_FAILURE: "Error while starting optimization",
  },
  STOP_MOVE: {
    SUCCESS: "Stops updated",
    FAILURE: "Error while moving stops",
  },
  PARAMETERS: {
    UPDATE_SUCCESS: "Parameter custom value updated",
    UPDATE_FAILURE: "Error updating the parameter custom value",
  },
  ROUTE_UPDATE: {
    NO_ROUTE_SELECTED: "Please select atleast one route to update",
    NO_NONTRAPROUTE_SELECTED:
      "Please select atleast one non trap route to update",
    ROUTENAME_EXISTS: "Multiple routes cannot have same name",
    STARTTIME_EMPTY: "Cannot assign empty start time to a route",
    STARTTIME_INVALID: "Please assign a valid route start time",
    STATUS_EMPTY: "Cannot assign empty status to a route",
    TRAILER_EMPTY: "Cannot remove trailer from a route",
    ROUTETYPE_EMPTY: "Cannot remove route type from a route",
  },
  ROUTE_MERGE: {
    ROUTE_EXIST: "Route with same name already exists",
    IN_PROGRESS: "Merging routes in progress",
    FAILURE: "Failed to merge routes",
  },
  STOP_UPDATE: {
    NO_STOP_SELECTED: "Please select a delivery stop to update",
    ROUTE_EMPTY: "Cannot assign empty route to a stop",
    ROUTE_UNRTD: "Cannot assign a stop to UNRTD",
    STOP_TIME: "Stop time updated",
  },
  SHIPMENT_UPDATE: {
    NO_NON_ARRIVED_SHIPMENT_SELECTED:
      "Please select a non arrived shipment to update IBETA",
    NO_INPLAN_SHIPMENT_SELECTED:
      "Please select atleast one in plan shipment to update",
    NO_SHIPMENT_SELECTED: "Please select atleast one shipment to update",
    ROUTE_EMPTY: "Cannot assign empty route to a shipment",
    IBETA_EMPTY: "Cannot assign empty value to IB ETA",
    IBETA_INVALID: "Please assign a valid Datetime value for IB ETA",
    PREPTIME_EMPTY: "Cannot assign empty value to prep time",
    PREPTIME_INVALID: "Please assign a valid value for prep time",
    EARLY_LATE_CTA_EMPTY: "Cannot assign empty value to appointment window",
    EARLY_LATE_CTA_INVALID:
      "Please assign a valid value for appointment window",
    PSE_EMPTY: "Cannot assign empty value to PSE",
    MAX_TRAILER: "Cannot assign empty value to Max Trailer",
    PSE_ZEROVALUE: "Cannot assign zero value to PSE",
    NON_UPDATED_PROS: "Please select shipments with only updated APT windows to revert",
    NON_DELIVERY_DATE_PROS: "Please select shipments with valid delivery date only",
    NO_SHIPMENT_SELECTED_APT: "Please select atleast one shipment to revert APT window",
    NO_SHIPMENT_SELECTED_SET_APT: "Please select atleast one shipment to set APT window",
    NO_SHIPMENT_SELECTED_FROZEN_PALLETS: "Please select atleast one shipment to revert frozen pallets",
    NO_SHIPMENT_SELECTED_NONFROZEN_PALLETS: "Please select atleast one shipment to revert non-frozen window",
    NO_SHIPMENT_SELECTED_IBETA: "Please select atleast one shipment to revert IBETA",
  },
  KPI: {
    FETCH_DATA_FAILURE: "Failed to get KPI data",
  },
  SCENARIO: {
    FETCH_DATA_FAILURE: "Error fetching scenario information",
    UPDATE_SCENARIONAME_EMPTY: "Scenario name cannot be empty",
    UPDATE_ACTIVESCENARIO_FAILURE: "Error updating Active scenario",
    COPY_NO_SCENARIO_SELECTED: "Please select the scenario to copy from",
    COPY_NO_EXISTING_SCENARIO_SELECTED:
      "Please select an existing scenario to copy from",
  },
  STEM_MILES: {
    FETCH_DATA_FAILURE: "Error fetching stem miles information",
    UPDATE_MILES_EMPTY: "Stem miles cannot be empty",
  },
  ZONE_MILES: {
    FETCH_DATA_FAILURE: "Error fetching zone miles information",
    UPDATE_MILES_EMPTY: "Zone miles cannot be empty",
  },
  TERMINAL_ACCESS: {
    FETCH_DATA_FAILURE: "Error fetching terminal access information",
    FETCH_TERMINAL_DATA_FAILURE: "Error fetching terminal list",
  },
  TRAILER: {
    UPDATE_CUSTOMVALUE_ISGREATER:
      "Custom value cannot be greater than available count",
  },
  WAVE: {
    FETCH_DATA_FAILURE: "Error fetching waves information",
    UPDATE_INVALID: "Wave name and wave time should have a valid value",
    UPDATE_WAVENAME_UNIQUE: "Wave Name must be unique",
    UPDATE_WAVETIME_UNIQUE: "Wave Time must be unique",
    UPDATE_DELETE_LAST_WAVE: "Cannot delete the last available wave",
  },
  STOP_MOVE_UNDO: {
    SUCCESS: "Stop move undo successful",
    FAILURE: "Failed to undo stop move",
  },
  LASSO: {
    UNDO_FAILED: "Undo failed",
    ROUTE_CREATION_FAILED: "Failed to create route",
  },
  NOTIFICATION: {
    DELETION_INPROGRESS: "Deleting notification...",
    DELETION_SUCCESS: "Notification deleted",
    DELETION_FAILED: "Failed to delete notification",
    FETCH_DATA_FAILURE: "Error fetching notifications",
    ADD_SUCCESS: "Notification Added",
    ADD_FAILED: "Failed to create new notification",
    UPDATE_SUCCESS: "Notification updated",
    UPDATE_FAILED: "Failed to update notification",
    NO_CHANGES: "No changes to save",
  },
  DRIVER_PREF: {
    FETCH_DATA_FAILURE: "Failed to fetch driver preferences",
    STARTTIME_EMPTY: "Zone start time cannot be empty",
    STARTTIME_INVALID: "Please assign valid start time to a zone",
  },
  EQUIPMENT_MAPPING: {
    FETCH_DATA_FAILURE: "Error fetching equipment mapping data",
    UPDATE_SUCCESS: "Updated equipment mapping",
    UPDATE_FAILURE: "Failed to update equipment mapping",
  },
  PRO_HISTORY: {
    EMPTY_PROID_SEARCH: "Please enter a valid Pro ID to search",
  },
  DRIVER_PERFORMANCE: {
    FETCH_DATA_FAILURE: "Error fetching driver performance data",
  },
  NEXT_STOP_COMPLIANCE: {
    FETCH_DATA_FAILURE: "Error fetching next stop compliance information",
  },
  OPTIMIZATION_PICKUP: {
    OPTIMIZATION_FAILURE: "Error fetching optymized pickup solution",
    NO_ACTIVE_DRIVER: "There is no active driver available to optymize.",
    REASSIGNMENT_FAILURE: "Failed to Reassign Pickup",
    PICKUP_UPDATE_FAILURE: "Unable to update pickup properties",
    PICKUPWINDOW_EMPTY: "Cannot assign empty value to pickup window",
    PICKUPWINDOW_INVALID: "Please assign a valid value for pickup window",
    PSE_EMPTY: "Cannot assign empty value to PSE",
    PSE_ZEROVALUE: "Cannot assign zero value to PSE",
    UPDATE_SUCCESS: "Pickup properties updated",
  },
  GROUP_MESSAGE: {
    SUCCESS: "Message Sent Successfully!",
    FAILURE: "Message not sent, Please try again!",
  },
  CUSTOMER_MANAGEMENT: {
    FAILURE: "Failed to update customer data",
    SUCCESS: "Customer management data updated",
    GET_FAILURE: "Failed to fetch customer data",
    GET_CUSTOMER_ROUTES_FAILURE: "Failed to fetch customer routes",
  },
  PROCESS_DELIVERY: {
    ADE_REQUIRED: "ADE Number is required",
    INVALID_ADE_LENGTH: "ADE Number should be 7 to 9 digits",
  },
  END_TRIP: {
    SUCCESS: "Trip Ended Successfully!",
    FAILURE: "End Trip Failed!",
  },
  TRAILER_HOOKED: {
    SUCCESS: "Trailer Hooked Successfully!",
    FAILURE: "Trailer Hook Failed!",
  },
  TRAILER_DROP: {
    SUCCESS: "Trailer Drop Successfully!",
    FAILURE: "Trailer Drop Failed!",
  },
  BOBTAIL_PROCESSED: {
    SUCCESS: "Bobtail Processed Successfully!",
    FAILURE: "Bobtail Process Failed!",
  },
  USAGE_REPORT: {
    FETCH_PUBLISHED_TERMINALS_FAILURE: "Error fetching published terminals",
    FETCH_USAGE_DETAILS_FAILURE: "Error fetching usage details",
    SELECT_DATE_RANGE: "Please select a date range",
    SELECT_TERMINAL: "Please select at least one terminal",
  },
  DROP_YARDS: {
    EDIT_IN_PROGRESS:
      "Edit in progress. Please finish the current edit before starting a new one.",
    NO_DROP_YARD_WITHIN_REGION:
      "No drop yards found within the selected region",
    MULTIPLE_DROP_YARDS_WITHIN_REGION:
      "Multiple drop yards found within the selected region",
    DROP_YARD_REGION_OVERLAPPING:
      "Drop yard region is overlapping with another drop yard",
    DROP_YARD_REGION_ALREADY_EXISTS: "Drop yard region already exists",
  },
};

export default MESSAGES;
